import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import React, { Fragment, useCallback, useState } from 'react';
import { Button, Create, SimpleForm, TextInput } from 'react-admin';

export const PostQuickCreateButton = (props) => {
  const [showDialog, setshowDialog] = useState(false);
  const handleClick = useCallback(() => {
    setshowDialog(true);
  }, [showDialog]);

  const handleCloseClick = useCallback(() => {
    setshowDialog(false);
  }, [showDialog]);

  return (
    <Fragment>
      <Button onClick={handleClick} label="ra.action.create">
        <IconContentAdd />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create user">
        <DialogTitle>Create user</DialogTitle>
        <DialogContent>
          <Create resource="user" basePath="/" {...props}>
            <SimpleForm>
              <TextInput source="email" />
            </SimpleForm>
          </Create>
        </DialogContent>
        <DialogActions>
          <Button label="ra.action.cancel" onClick={handleCloseClick}>
            <IconCancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default PostQuickCreateButton;
